import { getNavKeyFromPath, SIDEBAR_NAV } from '@/app/config/nav';

function navLabelFromKey(key: string): string {
  return SIDEBAR_NAV.find((item) => item.key === key)?.label ?? key;
}

export function buildPageBreadcrumb(pathname: string, workspaceLabel: string): string[] {
  const navKey = getNavKeyFromPath(pathname);
  return [workspaceLabel, navLabelFromKey(navKey)];
}
